import React, { Component } from 'react'
import OrderListModal from './modal/OrderListModal'
import LuckyDrawWheel from '../components/LuckyDrawWheel'
import FacebookLoginButton from './components/FacebookLoginButton';
import { pageReload } from '../util/PageReload';
import BillSummaryDetail from './BillSummaryDetail';
import './Billing.scss';
import { nl2br } from './Helper/helper';
import AppData from "../Model/AppData";
// import html2canvas from 'html2canvas';
class Billing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            luckyDrawing: false,
            luckydrawSpinning: false
        };
        this.onBtnContactClicked = this.onBtnContactClicked.bind(this)
        this.child = React.createRef()
    }

    componentDidMount() {
        if (typeof FB !== 'undefined') {
            // FB js already loaded, which mean that Facebook
            // login button rendering already ran while this
            // component is not mounted yet. We trigger to run
            // the rendering again to render the Facebook Login
            // button. Else it will be a empty div
            FB.XFBML.parse()
        }
    }

    render() {
        if (!this.props.app.isReadyFor(this)) {
            return <div></div>
        }
        return (
            <div>
                <div>
                    {this.renderHeader()}
                    {this.renderContent()}
                </div>
                <OrderListModal
                    showRefNo
                    app={this.props.app}
                    tableSession={this.props.app.state.table_session}
                    show={true}
                    bill={this.props.app.state.bill}
                    orders={this.props.app.state.orders}
                    menuItems={this.props.app.state.menuItems}
                />

                <OrderListModal
                    app={this.props.app}
                    title={lang.contact_us}
                    id="contact-us"
                    body={this.getContactModal()} />
                { AppData.data.isMerchantHasFeature('disable_logo_at_user_order_page') ? null
                :
                <div id="billing-label" className="text-center" style={{ width: '100%', position: 'fixed', bottom: '0px', marginTop: '20px', }}>
                    <a href="#" style={{ textDecoration: 'none', color: '#fff' }}>{lang.powered_by_orderlah}</a>
                </div>
                }
            </div>
        )
    }
    renderHeader() {
        return (
            <div>
                <div>
                    <nav className={this.props.merchant ? "navbar navbar-default" : "navbar navbar-default navbar-fixed-top"}>
                        <div className="container">
                            <div className="navbar-header" style={{ width: "100%", margin: "0px" }}>
                                <span className="navbar-brand">{lang.table} {this.props.app.state.table.name}</span>
                                {/* <img src="/image/orderlah_1row.png" style={{height:"45px",padding: "0px 0px 5px 0px"}}/> */}
                                <button type="button" className="btn btn-primary pull-right navbar-btn" data-toggle="modal" data-target="#orderListModal">{lang.check_orders}</button>
                            </div>
                        </div>
                    </nav>
                </div>
                <div id="billing-label" className="text-center" style={{ marginTop: '58px' }}>{this.state.luckydrawSpinning ? lang.good_luck : lang.billing}</div>
                {/* <h4 className="text-center">Please pay at counter</h4> */}
            </div>
        )
    }
    isReadyForCollection = () => {
        const orders = this.props.app.state.orders || []
        return orders.find(order => order.quantity != order.quantity_served) == null
    }
    readyForCollection = () => {
        return <div className="mb-2">
            <div style={{textAlign:"center"}}>
                <span style={{fontSize: "20pt"}} className="mr-3"><i className="fa fa-check text-success"></i></span>
                Your order is ready for collection
            </div>

        </div>
    }
    setArrivedForPickup = () => {
        $.ajax({
            url     : `/customer/table_sessions/${this.props.app.state.table_session.id}/arrived_for_pickup`,
            type    : 'post',
            success : (res) => {

            }
        })
    }
    renderContent() {
        const isReadyForCollection = this.isReadyForCollection()
        const css = isReadyForCollection ? {border: '2px solid green', color: "green"} : {border: '1px solid black'}
        const tableSession = this.props.app.state.table_session

        const isAllowSetArrivedForPickup = tableSession && tableSession.is_drive_through && !tableSession.customer_arrived_at
        const isArrivedForPickup = tableSession && tableSession.is_drive_through && tableSession.customer_arrived_at
        return <div className="mb-5">
            <div className={this.state.luckyDrawing ? '' : 'hide'}>{this.renderLuckyDraw()}</div>
            {
                this.props.app.state.table_session.pickup &&
                <div className='col-sm-12' style={{ padding: '50px 10px 10px 10px', marginBottom: "10px", backgroundColor: "white" }}>
                    <h4 style={{textAlign: 'center'}}>{lang.your_order_number}</h4>
                    <br />
                    <h1 style={{...css, margin: 'auto', textAlign: 'center', padding: '10px', maxWidth: '200px', borderRadius: '5px'}}>{this.props.app.state.table_session.queue_number}</h1>
                    <div style={{textAlign: "center"}} className="mt-2">{lang.ref_no}: {(this.props.app.state.table_session.id+"").padStart(8,"0")}</div>
                    <br />
                    {isReadyForCollection && this.readyForCollection()}
                    {
                        !isArrivedForPickup &&
                        <p style={{textAlign: 'center'}}>{lang.confirm_new_order_reminder}</p>
                    }
                    {
                        isAllowSetArrivedForPickup &&
                        <div style={{textAlign:"center"}}>
                            <button class="btn-sm btn btn-primary" style={{textAlign: 'center'}} onClick={this.setArrivedForPickup}>I'm here, send me my orders please.</button>
                        </div>
                    }
                    {
                        isArrivedForPickup &&
                        <div style={{textAlign:"center"}}>
                            Please wait, your orders will be sent to you shortly
                        </div>
                    }
                </div>
            }
            <div className={this.state.luckyDrawing ? 'hide' : ''}>{this.renderBilling()}</div>
        </div>
    }
    renderLuckyDraw() {
        if (this.props.app.state.merchant.lucky_draw_id == null) {
            return null
        }
        return <div style={{ marginTop: "5%" }}>
            <div style={{ textAlign: "center", height: "100px", padding: "0px 0px 5px 0px", margin: "0px 0px 5px 0px" }}>
                <img src="/image/orderlah_logo.png" style={{ height: "100%", width: "auto" }} />
            </div>
            <LuckyDrawWheel
                ref={this.child}
                user={this.props.app.state.user}
                merchant_id={this.props.app.state.table_session.merchant_id}
                started={
                    () => {
                        this.setState({ luckydrawSpinning: true })
                    }
                }
                ended={
                    () => {
                        this.setState({ luckydrawSpinning: false, luckyDrawing: false })
                    }
                }
            />
        </div>
    }
    onOrderAgain = () => {
        if (this.props.app.state.table_session.pickup) {
            // This is pickup/delivery mode
            // Just need to "clear" table_session_id from session, then
            // refresh page and get ready for new order
            $.ajax({
                url     : `/customer/clear_table_session`,
                type    : "post",
                success : res => {
                    pageReload.reload()
                }
            })
        }
        else if (this.isNoPinSingleSessionMode()) {
            $.ajax({
                url     : `/active_for_user_view/close`,
                type    : "post",
                success : res => {
                    // Firebase update will handle the UI change
                    // no need to do anything here
                }
            })

            setTimeout(() => {
                pageReload.reload()
            }, 5000)
        }
        else {
            // close_bill_on_order_confirmed mode for Cash on Delivery style kopitiam
            // Fire API to close current session. On table session change, page will be
            // handled by firebase listener
            $.ajax({
                url     : `/bills/${this.props.app.state.bill.id}/user_close`,
                type    : "post",
                success : res => {
                    // Firebase update will handle the UI change
                    // no need to do anything here
                }
            })
        }
    }

    isNoPinSingleSessionMode = () => {
        return this.props.app.isMerchantHasFeature('no_pin_single_session_mode')
    }
    orderAgainButton = () => {
        const orderAgainButton = <div className={`cta`} style={{flex: "1 0 100px"}}>
            <button className="btn btn-primary btn-block" disabled={!!this.state.isOrderAgain}
                    onClick={this.onOrderAgain}>
                {lang.order_again}
            </button>
        </div>

        if (this.isNoPinSingleSessionMode()) {
            return orderAgainButton
        } else if (!this.props.app.state.merchant.close_bill_on_order_confirmed && !this.props.app.state.table_session.pickup) {
            return null
        }
        return orderAgainButton
    }
    processPhoneNumber = () => {
        const { merchant } = this.props.app.state
        if (merchant) {
            let numberToCall = merchant.phone_number.replace(" ", "").replace("-", "")
            let firstDigit = numberToCall.substr(0, 1)
            firstDigit = numberToCall.substr(0,1)
            if (firstDigit == "0") {
                numberToCall = "+6" + numberToCall
            }
            else if (firstDigit == "6") {
                numberToCall = "+" + numberToCall
            }
            return numberToCall
        }
    }
    callMerchant = () => {
        return <a className="cta full-flex" href={`tel:${this.processPhoneNumber()}`}>
            <button className="btn btn-success btn">
                <i className="fas fa-phone"></i> {lang.call_phone}
            </button>
        </a>
    }
    whatsAppMerchant = () => {
        return <a className="cta full-flex" href={`https://api.whatsapp.com/send?phone=${this.processPhoneNumber()}`} target="_blank">
            <button className="btn btn-success btn">
                <i className="fab fa-whatsapp"></i> {lang.whatsapp || "WhatsApp"}
            </button>
        </a>
    }
    renderBilling() {
        const { merchant } = this.props.app.state
        let showLogo = AppData.data.isMerchantHasFeature('disable_logo_at_user_order_page')

        const isAllowCallMerchant = !AppData.data.isMerchantHasFeature('billing_page_disable_call_merchant')
        const isAllowWhatsappMerchant = !AppData.data.isMerchantHasFeature('billing_page_disable_whatsapp_merchant')
        return (
            <div className="container text-center" style={{ marginTop: "5%" }}>
                {this.renderLogo()}
                {this.renderTotal()}
                {this.luckyDrawButton()}
                {/* {this.html2canvasButton()} */}
                {
                    (isAllowCallMerchant || isAllowWhatsappMerchant) && merchant && merchant.phone_number && !showLogo &&
                    <div className="billing-cta-container mb-2 text-left" style={{display: "flex"}}>
                        {isAllowCallMerchant && this.callMerchant()}
                        {isAllowWhatsappMerchant && this.whatsAppMerchant()}
                    </div>
                }
                <div className={`billing-cta-container ${this.props.app.state.merchant.lucky_draw_id == null ? "": "mt-5"} mb-5`} style={{display: "flex", justifyContent: "space-between"}}>
                    {this.orderAgainButton()}
                </div>
                {this.billingPageHint()}
                {this.fbLikeButton()}
            </div>
        )
    }
    billingPageHint = () => {
        const billingPageHintText = this.props.app.getMerchantSettingValue('billing_page_hint')
        if (billingPageHintText) {
            return <p className="text-danger mt-1" style={{fontSize: "120%", fontWeight: "bold"}}>
                {nl2br(billingPageHintText)}
            </p>
        }
        return null
    }

    renderLogo() {
        let image_path = (this.props.app.state.merchant && this.props.app.state.merchant.logo_url) ? this.props.app.state.merchant.display_logo : "";
        return (
            <div id="logo" className="clearfix">
                {image_path && <img style={{ float: "none" }} src={image_path} />}
                {(this.props.app.state.bill.voucher_history_id != null && this.props.app.state.voucher_history != null) ? "" :
                    <p style={{ margin: "0px", fontSize: "22px" }}>{lang.thanks_coming}</p>}
                {/* <span className="navbar-brand">{lang.table} {this.props.app.state.table.name}</span> */}
            </div>
        )
    }

    renderTotal() {
        return <BillSummaryDetail currencyName={this.props.currencyName} bill={this.props.app.state.bill} voucher_history={this.props.app.state.voucher_history} merchant={this.props.app.state.merchant} />
    }
    luckyDrawButton() {
        if (this.props.app.state.merchant.lucky_draw_id != null && this.props.app.state.bill.voucher_history_id == null && this.state.luckyDrawing == false && this.state.luckydrawSpinning == false) {
            return (
                <div>
                    {
                        login_only_luckydraw && this.props.app.state.user == null ? <span style={{ fontSize: "16px", fontWeight: "bold" }}>Sign in for lucky draw</span> : <div>
                            <span style={{ fontSize: "16px", fontWeight: "bold" }}>{lang.ask_for_draw}</span>
                            <button
                                className="btn btn-danger"
                                style={{ marginTop: "0px", width: "80%", fontSize: "16px", fontWeight: "bold" }}
                                onClick={
                                    () => {
                                        this.setState({
                                            luckyDrawing: true
                                        })
                                        this.child.current.startDraw()
                                    }
                                }>{lang.lucky_draw}</button>
                        </div>
                    }
                    {login_only_luckydraw && <FacebookLoginButton user={this.props.app.state.user} login={(user) => { this.props.app.setState({ user: user }) }} />}
                </div>
            )
        }
        return ""
    }

    fbLikeButton() {
        if (this.props.app.state.merchant.lucky_draw_id != null && this.props.app.state.bill.voucher_history_id == null && this.state.luckyDrawing == false && this.state.luckydrawSpinning == false) {
            return ""
        }
        let showLogo = AppData.data.isMerchantHasFeature('disable_logo_at_user_order_page')
        return (
            this.props.app.state.merchant
            && (this.props.app.state.merchant.is_show_orderlah_contact === "1")
            && !showLogo
            && <div className="container" style={{ display: "inline-block" }}>
                <button type="button" className="btn btn-primary btn-sm" style={{ margin: "5px auto", width: "80%" }} onClick={this.onBtnContactClicked}>{lang.contact_us}</button>

                <p style={{ fontSize: "16px", margin: "0px" }}>{lang.like_share}</p>
                <div>
                    <div className="fb-like"
                        data-href="https://www.facebook.com/orderlah.malaysia/"
                        data-layout="button_count" data-action="like"
                        data-size="large" data-show-faces="false"
                        data-share="true">
                    </div>
                </div>
            </div>
        )
    }

    onBtnContactClicked() {
        $('#contact-us').modal();
    }

    getContactModal() {
        return (
            <aside className="sidebar">
                <div className="single contact-info">
                    <ul className="list-unstyled">
                        <li>
                            <div className="icon"><i className="fa fa-envelope"></i></div>
                            <div className="info"><p><span style={{ position: "absolute", top: "28px" }}>sales@order-lah.com</span> <br /> &nbsp;</p></div>
                        </li>
                        <li>
                            <div className="icon"><i className="fa fa-phone"></i></div>
                            <div className="info"><p>Jimmy: 016-204 6830<br />
                                Champion: 012-366 6623</p>
                            </div>
                        </li>
                        <li>
                            <div className="icon" style={{ marginTop: "6px" }}><i className="fa fa-map-marker"></i></div>
                            <div className="info"><p> Sitec, E-28-1, i-City, Jalan Multimedia 7/AG,
                                {/* Selangor Digital Creative Centre, <br /> */}
                                40000 Shah Alam, Selangor</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </aside>
        )
    }

}
export default Billing;